import type { HistoryState } from './history.reducer';
import type { HistoryChange } from './history.model';

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { HISTORY_FEATURE_KEY } from './history.reducer';

export const selectHistoryState = createFeatureSelector<HistoryState>(HISTORY_FEATURE_KEY);

export const selectHistoryPrev = createSelector(
    selectHistoryState,
    (state: HistoryState): HistoryChange[] => state.prev
);

export const selectHistoryLastPrev = createSelector(
    selectHistoryPrev,
    (prev: HistoryChange[]): HistoryChange => prev[prev.length - 1]
);

export const selectIsHistoryPrevEmpty = createSelector(
    selectHistoryPrev,
    (prev: HistoryChange[]): boolean => prev.length === 0
);

export const selectHistoryNext = createSelector(
    selectHistoryState,
    (state: HistoryState): HistoryChange[] => state.next
);

export const selectIsHistoryNextEmpty = createSelector(
    selectHistoryNext,
    (next: HistoryChange[]): boolean => next.length === 0
);

export const selectHistoryLastNext = createSelector(
    selectHistoryNext,
    (next: HistoryChange[]): HistoryChange => next[0]
);
